/**
 * 생기부 행동특성 및 종합의견 — 학생 특성 칩.
 *
 * - id 는 이벤트 집계 키라서 한 번 정하면 바꾸지 않는다. 새 칩은 새 번호를 붙인다.
 * - 같은 그룹·같은 종류 안에서는 배열 순서가 기본 노출 순서다(운영에서 많이 쓴 순).
 * - 그룹 label 과 칩 글자는 교사가 저장한 내 칩·이전 입력과 맞물려 있어 함부로 바꾸지 않는다.
 * - type: positive(잘하는 점) / negative(도와줄 점)
 */

const P = 'positive';
const N = 'negative';

const chip = (id, text, type, extra = {}) => ({ id, text, type, ...extra });

export const BEHAVIOR_TRAIT_GROUPS = [
  {
    key: 'school',
    label: '학교생활',
    chips: [
      chip('bt_school_p01', '성실함', P, { aliases: ['착실함', '근면함'] }),
      chip('bt_school_p02', '책임감 있음', P, { aliases: ['책임감'] }),
      chip('bt_school_p04', '예의바름', P, { aliases: ['예의 바름', '공손함', '바른 태도'] }),
      chip('bt_school_p10', '맡은 업무 성실 수행', P, { aliases: ['1인 1역', '맡은 역할'] }),
      chip('bt_school_p03', '규칙을 잘 지킴', P),
      chip('bt_school_p05', '자기관리 잘함', P),
      chip('bt_school_p17', '학급 역할 책임 수행', P),
      chip('bt_school_p12', '모범적임', P),
      chip('bt_school_p09', '학급 일에 앞장섬', P),
      chip('bt_school_p11', '부지런함', P),
      chip('bt_school_p22', '생활 루틴 안정적', P),
      chip('bt_school_p21', '행사 참여 적극적', P),
      chip('bt_school_p13', '청소를 솔선수범함', P),
      chip('bt_school_p16', '안내사항 확인 꼼꼼', P),
      chip('bt_school_p07', '정리정돈 잘함', P),
      chip('bt_school_p08', '시간 약속 잘 지킴', P),
      chip('bt_school_p24', '학급 분위기 정돈에 기여', P),
      chip('bt_school_p14', '출결 관리 성실', P),
      chip('bt_school_p06', '봉사활동 적극 참여', P),
      chip('bt_school_p20', '안전수칙 잘 지킴', P),
      chip('bt_school_p25', '약속 이행 꾸준함', P),
      chip('bt_school_p15', '준비물 관리 철저', P),
      chip('bt_school_p23', '공동 공간 배려', P),
      chip('bt_school_p18', '공용물품 관리 잘함', P),
      chip('bt_school_p19', '이동수업 준비 빠름', P),
      chip('bt_school_p26', '인사를 잘함', P, { aliases: ['먼저 인사함', '인사성 바름'] }),
      chip('bt_school_p27', '솔선수범함', P, { aliases: ['솔선수범', '앞장섬'] }),
      chip('bt_school_p28', '학급 회의 참여 적극적', P, { aliases: ['학급회의', '자치 활동'] }),
      chip('bt_school_p30', '기본 생활습관 바름', P, { aliases: ['생활습관', '바른 생활'] }),
      chip('bt_school_p31', '물건을 아껴 씀', P, { aliases: ['절약', '아껴 씀'] }),
      chip('bt_school_p32', '질서를 잘 지킴', P, { aliases: ['차례를 잘 지킴', '줄서기'] }),
      chip('bt_school_p33', '분리수거 잘함', P, { aliases: ['분리배출', '재활용'] }),
      chip('bt_school_p34', '급식 예절 바름', P, { aliases: ['급식을 골고루 먹음', '편식하지 않음'] }),
      chip('bt_school_p35', '교실 환경 가꿈', P, { aliases: ['화분', '교실 꾸미기'] }),
      chip('bt_school_p36', '온라인 예절 지킴', P, { aliases: ['디지털 예절', '네티켓'] }),
      chip('bt_school_p37', '행사 준비를 도움', P, { aliases: ['행사 도우미'] }),
      chip('bt_school_n01', '지각이 잦음', N, { aliases: ['지각'] }),
      chip('bt_school_n02', '과제 제출이 늦음', N),
      chip('bt_school_n05', '정리 습관 부족', N),
      chip('bt_school_n12', '생활규칙 반복 안내 필요', N),
      chip('bt_school_n04', '규칙 준수 어려움', N),
      chip('bt_school_n15', '학급활동 참여 소극적', N),
      chip('bt_school_n08', '안내사항 확인 부족', N),
      chip('bt_school_n03', '결석이 잦음', N, { aliases: ['결석'] }),
      chip('bt_school_n09', '시간 관리 도움 필요', N),
      chip('bt_school_n10', '역할 수행 지속성 부족', N),
      chip('bt_school_n07', '준비물 누락 잦음', N),
      chip('bt_school_n14', '생활 리듬 불규칙', N),
      chip('bt_school_n13', '안전수칙 주의 필요', N),
      chip('bt_school_n06', '등교 준비 미흡', N),
      chip('bt_school_n11', '공용공간 정리 부족', N),
      chip('bt_school_n16', '조퇴가 잦음', N, { aliases: ['조퇴'] }),
      chip('bt_school_n17', '수업 중 휴대폰 사용 지도 필요', N, { aliases: ['휴대폰', '핸드폰', '스마트폰'] }),
      chip('bt_school_n18', '물건 분실이 잦음', N, { aliases: ['분실', '잃어버림'] }),
      chip('bt_school_n19', '청소 참여 소극적', N, { aliases: ['청소 안 함'] }),
      chip('bt_school_n20', '스마트기기 사용 시간 조절 필요', N, { aliases: ['게임', '스마트기기', '미디어 사용'] }),
      chip('bt_school_n21', '복장 규정 안내 필요', N, { aliases: ['복장', '교복'] }),
    ],
  },
  {
    key: 'friend',
    label: '교우관계',
    chips: [
      chip('bt_friend_p02', '친화력 좋음', P, { aliases: ['친구가 많음', '사교성'] }),
      chip('bt_friend_p01', '리더십 있음', P, { aliases: ['리더', '이끎'] }),
      chip('bt_friend_p09', '두루 잘 어울림', P),
      chip('bt_friend_p03', '배려심 깊음', P, { aliases: ['배려', '착함'] }),
      chip('bt_friend_p06', '사교적임', P, { aliases: ['외향적'] }),
      chip('bt_friend_p14', '상대 의견 존중', P),
      chip('bt_friend_p10', '친구들에게 신뢰받음', P),
      chip('bt_friend_p04', '협력 잘함', P),
      chip('bt_friend_p25', '관계 형성 안정적', P),
      chip('bt_friend_p07', '경청을 잘함', P),
      chip('bt_friend_p12', '포용력 있음', P),
      chip('bt_friend_p08', '소외된 친구 챙김', P),
      chip('bt_friend_p21', '도움 제공을 잘함', P),
      chip('bt_friend_p19', '다름을 존중함', P),
      chip('bt_friend_p05', '갈등 조절 잘함', P),
      chip('bt_friend_p16', '갈등 후 관계 회복 잘함', P),
      chip('bt_friend_p15', '모둠활동 조율', P),
      chip('bt_friend_p18', '팀원 격려', P),
      chip('bt_friend_p23', '협동 과제 기여', P),
      chip('bt_friend_p11', '칭찬을 잘함', P),
      chip('bt_friend_p20', '도움 요청을 잘함', P),
      chip('bt_friend_p22', '공정하게 의견을 들음', P),
      chip('bt_friend_p24', '친구 장점 발견', P),
      chip('bt_friend_p13', '또래 상담 능력', P),
      chip('bt_friend_p17', '새 친구 적응 도움', P, { aliases: ['전학 온 친구'] }),
      chip('bt_friend_p26', '교우관계 원만', P, { aliases: ['교우관계 좋음', '친구 관계 좋음'] }),
      chip('bt_friend_p27', '친절함', P, { aliases: ['상냥함', '다정함'] }),
      chip('bt_friend_p28', '유머러스함', P, { aliases: ['유머', '재미있음'] }),
      chip('bt_friend_p29', '분위기 메이커', P, { aliases: ['분위기를 밝게 함'] }),
      chip('bt_friend_p30', '먼저 다가감', P, { aliases: ['먼저 말을 걺'] }),
      chip('bt_friend_p31', '양보를 잘함', P, { aliases: ['양보'] }),
      chip('bt_friend_p32', '다툼을 말로 해결함', P, { aliases: ['대화로 해결'] }),
      chip('bt_friend_p33', '먼저 사과함', P, { aliases: ['사과를 잘함'] }),
      chip('bt_friend_p34', '친구 고민을 들어줌', P, { aliases: ['고민 상담'] }),
      chip('bt_friend_p35', '역할을 고르게 나눔', P, { aliases: ['역할 분담'] }),
      chip('bt_friend_n01', '관계 형성 도움 필요', N, { aliases: ['친구 관계 어려움', '교우관계 어려움', '친구가 적음'] }),
      chip('bt_friend_n02', '참여 표현이 적음', N),
      chip('bt_friend_n12', '장난의 선 지도 필요', N),
      chip('bt_friend_n04', '상대 입장 고려 연습 필요', N),
      chip('bt_friend_n08', '감정 표현이 직설적임', N),
      chip('bt_friend_n05', '갈등 조정 도움 필요', N),
      chip('bt_friend_n03', '공동 활동 배려 연습 필요', N),
      chip('bt_friend_n10', '관계 형성 시간 필요', N),
      chip('bt_friend_n07', '경청 태도 연습 필요', N),
      chip('bt_friend_n13', '타협 경험 필요', N),
      chip('bt_friend_n06', '의견 조율 도움 필요', N),
      chip('bt_friend_n09', '협동 활동 참여 편차', N),
      chip('bt_friend_n14', '모둠 역할 분담 어려움', N),
      chip('bt_friend_n15', '갈등 후 회복 지원 필요', N),
      chip('bt_friend_n11', '도움 요청 어려움', N),
      chip('bt_friend_n16', '장난이 많음', N, { aliases: ['장난꾸러기', '장난기'] }),
      chip('bt_friend_n17', '친한 친구에게만 치우침', N, { aliases: ['교우관계 폭이 좁음', '단짝'] }),
      chip('bt_friend_n18', '혼자 지내는 시간이 많음', N, { aliases: ['혼자 있음', '외톨이'] }),
      chip('bt_friend_n19', '말투가 거칠 때가 있음', N, { aliases: ['거친 말', '욕설', '비속어'] }),
      chip('bt_friend_n20', '거절 표현 연습 필요', N, { aliases: ['거절을 못함'] }),
      chip('bt_friend_n21', '또래 영향을 많이 받음', N, { aliases: ['친구 따라감'] }),
    ],
  },
  {
    key: 'mind',
    label: '인성',
    chips: [
      chip('bt_mind_p01', '긍정적임', P),
      chip('bt_mind_p02', '차분함', P, { aliases: ['조용함', '얌전함'] }),
      chip('bt_mind_p12', '명랑함', P),
      chip('bt_mind_p11', '따뜻한 심성', P, { aliases: ['착함', '마음씨'] }),
      chip('bt_mind_p06', '온화함', P),
      chip('bt_mind_p26', '꾸준히 노력함', P, { aliases: ['꾸준함', '노력'] }),
      chip('bt_mind_p18', '반듯한 심성', P),
      chip('bt_mind_p10', '솔직함', P),
      chip('bt_mind_p03', '끈기 있음', P, { aliases: ['끈기', '인내'] }),
      chip('bt_mind_p04', '겸손함', P),
      chip('bt_mind_p05', '정직함', P),
      chip('bt_mind_p28', '문제를 차분히 해결', P),
      chip('bt_mind_p08', '자존감 높음', P),
      chip('bt_mind_p29', '감사 표현을 잘함', P),
      chip('bt_mind_p16', '감수성 풍부', P),
      chip('bt_mind_p07', '감사하는 태도', P),
      chip('bt_mind_p13', '여유로움', P),
      chip('bt_mind_p24', '타인 입장 헤아림', P),
      chip('bt_mind_p09', '성숙함', P),
      chip('bt_mind_p20', '자기성찰 잘함', P),
      chip('bt_mind_p17', '도덕적임', P),
      chip('bt_mind_p21', '실수 후 회복 빠름', P),
      chip('bt_mind_p23', '감정 조절 안정적', P),
      chip('bt_mind_p22', '책임 있게 사과함', P),
      chip('bt_mind_p14', '용기 있음', P),
      chip('bt_mind_p15', '공감 능력 뛰어남', P),
      chip('bt_mind_p25', '절제력 있음', P),
      chip('bt_mind_p27', '배움에 겸손함', P),
      chip('bt_mind_p30', '정의감 있음', P),
      chip('bt_mind_p19', '공정함', P),
      chip('bt_mind_p31', '조용함', P, { aliases: ['얌전함', '말수가 적음'] }),
      chip('bt_mind_p32', '활발함', P, { aliases: ['적극적임', '에너지 넘침'] }),
      chip('bt_mind_p33', '밝음', P, { aliases: ['밝은 성격', '해맑음'] }),
      chip('bt_mind_p34', '쾌활함', P),
      chip('bt_mind_p35', '활기참', P),
      chip('bt_mind_p36', '웃음이 많음', P, { aliases: ['잘 웃음'] }),
      chip('bt_mind_p37', '침착함', P, { aliases: ['긴장된 상황에서도 침착함'] }),
      chip('bt_mind_p38', '자신감 있음', P, { aliases: ['당당함'] }),
      chip('bt_mind_p39', '참을성 있음', P, { aliases: ['인내심'] }),
      chip('bt_mind_p40', '신중함', P),
      chip('bt_mind_p41', '꼼꼼함', P, { aliases: ['세심함'] }),
      chip('bt_mind_p42', '의젓함', P, { aliases: ['듬직함', '어른스러움'] }),
      chip('bt_mind_p43', '열정적임', P, { aliases: ['열정'] }),
      chip('bt_mind_p44', '소신 있음', P, { aliases: ['주관이 뚜렷함'] }),
      chip('bt_mind_p45', '잘못을 솔직히 인정함', P, { aliases: ['인정'] }),
      chip('bt_mind_p46', '실패 후 다시 도전함', P, { aliases: ['재도전', '회복탄력성'] }),
      chip('bt_mind_p47', '고운 말을 씀', P, { aliases: ['바른 말', '언어 예절'] }),
      chip('bt_mind_p48', '어른을 공경함', P, { aliases: ['효', '공경'] }),
      chip('bt_mind_n01', '감정 기복 있음', N),
      chip('bt_mind_n02', '즉흥적 행동 조절 필요', N, { aliases: ['충동적임', '충동'] }),
      chip('bt_mind_n10', '자기표현 방식 개선 필요', N),
      chip('bt_mind_n14', '표현이 강한 편', N),
      chip('bt_mind_n04', '민감한 반응 조절 필요', N, { aliases: ['예민함', '예민'] }),
      chip('bt_mind_n15', '자기관리 지속성 부족', N),
      chip('bt_mind_n07', '감정 조절 연습 중', N),
      chip('bt_mind_n12', '책임 전가 경향', N),
      chip('bt_mind_n11', '실패 후 위축됨', N),
      chip('bt_mind_n08', '즉흥적 선택 잦음', N),
      chip('bt_mind_n05', '기다리는 태도 연습', N),
      chip('bt_mind_n06', '스스로 결정하는 경험 필요', N),
      chip('bt_mind_n03', '의견 조율 연습 필요', N),
      chip('bt_mind_n13', '사과와 회복 경험 필요', N),
      chip('bt_mind_n09', '피드백 수용 시간 필요', N),
      chip('bt_mind_n16', '소극적인 편', N, { aliases: ['소극적임', '내성적'] }),
      chip('bt_mind_n17', '수줍음이 많음', N, { aliases: ['소심함', '부끄러움'] }),
      chip('bt_mind_n18', '자신감 키우는 중', N, { aliases: ['자신감 부족', '자신감 없음'] }),
      chip('bt_mind_n19', '쉽게 긴장함', N, { aliases: ['긴장', '불안'] }),
      chip('bt_mind_n20', '실수를 두려워함', N, { aliases: ['완벽주의'] }),
      chip('bt_mind_n21', '승부에 민감함', N, { aliases: ['승부욕', '지는 것을 싫어함'] }),
      chip('bt_mind_n22', '자기 의견을 고수함', N, { aliases: ['고집'] }),
      chip('bt_mind_n23', '부정적 표현이 잦음', N, { aliases: ['불평', '투덜거림'] }),
    ],
  },
  {
    key: 'study',
    label: '교과학습',
    chips: [
      chip('bt_study_p01', '자기주도적임', P),
      chip('bt_study_p07', '수업 태도 바름', P),
      chip('bt_study_p02', '창의적임', P),
      chip('bt_study_p11', '과제 성실히 수행', P),
      chip('bt_study_p05', '호기심 많음', P),
      chip('bt_study_p03', '발표력 우수', P, { aliases: ['발표를 잘함', '말하기'] }),
      chip('bt_study_p12', '포기하지 않음', P),
      chip('bt_study_p04', '탐구력 뛰어남', P),
      chip('bt_study_p08', '질문을 잘함', P),
      chip('bt_study_p06', '논리적으로 표현함', P),
      chip('bt_study_p09', '관찰력 뛰어남', P),
      chip('bt_study_p17', '학습계획 실천', P),
      chip('bt_study_p26', '문제 해결 끈기', P),
      chip('bt_study_p14', '독서를 즐김', P),
      chip('bt_study_p10', '분석적 사고', P),
      chip('bt_study_p13', '계획적 학습', P),
      chip('bt_study_p21', '필기 정리 체계적', P),
      chip('bt_study_p18', '발표 준비 성실', P),
      chip('bt_study_p22', '수행평가 준비 철저', P),
      chip('bt_study_p23', '피드백 반영 빠름', P),
      chip('bt_study_p25', '모둠 과제 기여', P),
      chip('bt_study_p20', '자료 조사 능동적', P),
      chip('bt_study_p16', '개념 질문 적극적', P),
      chip('bt_study_p19', '근거 들어 토론함', P),
      chip('bt_study_p24', '탐구 주제 확장', P),
      chip('bt_study_p15', '오답 분석 꼼꼼', P),
      chip('bt_study_p27', '논리적임', P, { aliases: ['논리력'] }),
      chip('bt_study_p28', '문제 해결 능력', P, { aliases: ['해결력'] }),
      chip('bt_study_p29', '주도적임', P, { aliases: ['적극적임', '능동적'] }),
      chip('bt_study_p30', '계획적임', P, { aliases: ['계획성'] }),
      chip('bt_study_p31', '집중력이 좋음', P, { aliases: ['집중력', '몰입'] }),
      chip('bt_study_p32', '틀린 이유를 설명함', P, { aliases: ['오답 설명'] }),
      chip('bt_study_p33', '모르는 부분을 스스로 찾아봄', P, { aliases: ['스스로 찾음'] }),
      chip('bt_study_p34', '자료 출처를 확인함', P, { aliases: ['출처'] }),
      chip('bt_study_p35', '배운 내용을 생활과 연결', P, { aliases: ['적용', '연결'] }),
      chip('bt_study_p36', '독창적 아이디어', P, { aliases: ['아이디어'] }),
      chip('bt_study_p37', '글로 생각을 잘 표현함', P, { aliases: ['글쓰기', '표현력'] }),
      chip('bt_study_p38', '디지털 도구 활용 능숙', P, { aliases: ['태블릿', '컴퓨터 활용'] }),
      chip('bt_study_p39', '실험·관찰을 즐김', P, { aliases: ['실험', '관찰'] }),
      chip('bt_study_p40', '친구에게 설명을 잘함', P, { aliases: ['또래 가르치기', '설명'] }),
      chip('bt_study_n02', '집중 유지 도움 필요', N, { aliases: ['집중력 부족', '산만함'] }),
      chip('bt_study_n01', '학습 속도 조절 필요', N, { aliases: ['학습 속도 느림'] }),
      chip('bt_study_n04', '수업 태도 개선 필요', N),
      chip('bt_study_n03', '기본 개념 반복 필요', N),
      chip('bt_study_n08', '발표 자신감 부족', N, { aliases: ['발표를 어려워함'] }),
      chip('bt_study_n05', '과제 완성도 보완 필요', N),
      chip('bt_study_n13', '수업 집중 편차', N),
      chip('bt_study_n11', '학습계획 지속성 부족', N),
      chip('bt_study_n06', '과제 시작이 늦음', N),
      chip('bt_study_n16', '문제 해결 전 포기 경향', N),
      chip('bt_study_n09', '필기 정리 도움 필요', N),
      chip('bt_study_n15', '글쓰기 구조화 어려움', N),
      chip('bt_study_n10', '질문을 망설임', N),
      chip('bt_study_n14', '복습 습관 형성 중', N),
      chip('bt_study_n12', '자료 조사 깊이 부족', N),
      chip('bt_study_n07', '오답 정리 미흡', N),
      chip('bt_study_n17', '주의 전환이 잦음', N, { aliases: ['산만함', '산만'] }),
      chip('bt_study_n18', '긴 글 읽기 어려움', N, { aliases: ['읽기', '독해'] }),
      chip('bt_study_n19', '기초 연산 반복 필요', N, { aliases: ['계산', '연산'] }),
      chip('bt_study_n20', '어휘 이해 보완 필요', N, { aliases: ['어휘', '낱말'] }),
      chip('bt_study_n21', '평가 상황에서 긴장함', N, { aliases: ['시험 긴장', '시험 불안'] }),
      chip('bt_study_n22', '모르는 것을 넘기는 경향', N, { aliases: ['대충'] }),
    ],
  },
  {
    key: 'self',
    label: '개별특성',
    chips: [
      chip('bt_self_p01', '학급 회장', P, { aliases: ['회장'] }),
      chip('bt_self_p03', '부반장', P),
      chip('bt_self_p02', '반장', P),
      chip('bt_self_p08', '운동 재능', P, { aliases: ['운동을 잘함'] }),
      chip('bt_self_p10', '예술적 감각', P),
      chip('bt_self_p14', '봉사정신 투철', P),
      chip('bt_self_p34', '진로 탐색 꾸준함', P),
      chip('bt_self_p29', '체육대회 기여', P),
      chip('bt_self_p09', '음악 재능', P),
      chip('bt_self_p30', '문화예술 행사 참여', P),
      chip('bt_self_p22', '환경 지킴이', P),
      chip('bt_self_p24', '디지털 도우미', P),
      chip('bt_self_p11', '과학 관심', P),
      chip('bt_self_p17', '운동선수가 꿈', P),
      chip('bt_self_p25', '또래 멘토', P),
      chip('bt_self_p21', '에너지 지킴이', P),
      chip('bt_self_p04', '방송부원', P),
      chip('bt_self_p12', 'IT/코딩 관심', P),
      chip('bt_self_p05', '도서관 부원', P),
      chip('bt_self_p31', '프로젝트 리더', P),
      chip('bt_self_p16', '선생님이 꿈', P),
      chip('bt_self_p19', '학급 서기', P),
      chip('bt_self_p33', '자료 정리 담당', P),
      chip('bt_self_p07', '급식 도우미', P),
      chip('bt_self_p15', '다문화 이해', P),
      chip('bt_self_p13', '환경 보호 관심', P),
      chip('bt_self_p18', '의사/간호사가 꿈', P, { aliases: ['의사가 꿈', '간호사가 꿈'] }),
      chip('bt_self_p28', '도서 추천 활동', P),
      chip('bt_self_p27', '발표 대표', P),
      chip('bt_self_p06', '선도부원', P),
      chip('bt_self_p23', '안전 도우미', P),
      chip('bt_self_p32', '실험 도우미', P),
      chip('bt_self_p20', '학급 기자', P),
      chip('bt_self_p26', '행사 사회', P),
      chip('bt_self_p35', '학급 부회장', P, { aliases: ['부회장'] }),
      chip('bt_self_p36', '학급 실장', P, { aliases: ['실장'] }),
      chip('bt_self_p37', '학급 부실장', P, { aliases: ['부실장'] }),
      chip('bt_self_p38', '학생회 임원', P, { aliases: ['학생회', '전교 임원'] }),
      chip('bt_self_p39', '체육부장', P, { aliases: ['체육부'] }),
      chip('bt_self_p40', '학습부장', P, { aliases: ['학습부'] }),
      chip('bt_self_p41', '미화부장', P, { aliases: ['미화부', '환경부'] }),
      chip('bt_self_p42', '휴대폰 도우미', P, { aliases: ['핸드폰 도우미', '휴대폰 수거'] }),
      chip('bt_self_p43', '분리수거 도우미', P, { aliases: ['재활용 도우미'] }),
      chip('bt_self_p44', '우유 도우미', P),
      chip('bt_self_p45', '운동을 좋아함', P, { aliases: ['체육', '스포츠'] }),
      chip('bt_self_p46', '그림 그리기를 좋아함', P, { aliases: ['미술', '그림'] }),
      chip('bt_self_p47', '악기 연주를 즐김', P, { aliases: ['악기', '연주'] }),
      chip('bt_self_p48', '만들기를 좋아함', P, { aliases: ['공작', '손재주'] }),
      chip('bt_self_p49', '요리에 관심', P, { aliases: ['요리'] }),
      chip('bt_self_p50', '동물을 아낌', P, { aliases: ['동물', '반려동물'] }),
      chip('bt_self_p51', '역사에 관심', P, { aliases: ['역사'] }),
      chip('bt_self_p52', '우주·천문에 관심', P, { aliases: ['우주', '천문', '별'] }),
      chip('bt_self_p53', '과학자가 꿈', P, { aliases: ['과학자'] }),
      chip('bt_self_p54', '경찰관이 꿈', P, { aliases: ['경찰'] }),
      chip('bt_self_p55', '프로그래머가 꿈', P, { aliases: ['개발자', '프로그래머'] }),
      chip('bt_self_p56', '디자이너가 꿈', P, { aliases: ['디자인'] }),
      chip('bt_self_n01', '관심 분야 탐색 중', N),
      chip('bt_self_n02', '진로 목표 구체화 필요', N),
      chip('bt_self_n08', '활동 지속성 부족', N),
      chip('bt_self_n09', '자기 강점 인식 부족', N),
      chip('bt_self_n06', '특기 표현 소극적', N),
      chip('bt_self_n04', '발표 경험 부족', N),
      chip('bt_self_n03', '역할 수행 경험 부족', N),
      chip('bt_self_n10', '새로운 역할 도전 망설임', N),
      chip('bt_self_n05', '활동 참여 기회 부족', N),
      chip('bt_self_n07', '경험 정리 미흡', N),
      chip('bt_self_n11', '진로 고민 중', N, { aliases: ['꿈이 없음', '진로 미정'] }),
      chip('bt_self_n12', '취미 활동 탐색 중', N, { aliases: ['취미'] }),
    ],
  },
];

// 접힌 줄에 기본으로 보이는 칩 수 [잘하는 점, 도와줄 점]. 첫 화면 버튼 25개 이하(칩 19 + 더보기 5 + 찾기 1)를 지킨다.
// 모바일은 줄마다 옆으로 밀어 보는 한 줄이라 개수를 늘려도 높이가 늘지 않는다.
const DEFAULT_SLOTS = { school: [3, 1], friend: [3, 1], mind: [3, 1], study: [3, 1], self: [3, 0] };
export const COLLAPSED_SLOTS = { pc: DEFAULT_SLOTS, mobile: DEFAULT_SLOTS };

export const BEHAVIOR_TRAIT_CHIP_BY_ID = Object.freeze(
  BEHAVIOR_TRAIT_GROUPS.reduce((acc, group) => {
    group.chips.forEach((item) => { acc[item.id] = { ...item, groupKey: group.key, groupLabel: group.label }; });
    return acc;
  }, {})
);

export const BEHAVIOR_TRAIT_CHIP_BY_TEXT = Object.freeze(
  Object.values(BEHAVIOR_TRAIT_CHIP_BY_ID).reduce((acc, item) => {
    if (!acc[item.text]) acc[item.text] = item;
    return acc;
  }, {})
);
